import React from 'react';
import styled, { useTheme } from 'styled-components';
import { getManagementCompanyPath } from '@finect/front-resources/Products';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { AppLink } from '@finect/tabular-core/AppLink';
import { H5 } from '@finect/tabular-core/Headings';
import { Image } from '../../../Image';
import { getManagementCompanyIconUrl } from '../utils';
import { AssetsLabel, NumberLabel } from '../../Labels';
var Inner = styled(AppLink).withConfig({
  displayName: "Large__Inner",
  componentId: "sc-lauheu-0"
})(["display:block;flex-grow:1;flex-shrink:0;width:100%;border:1px solid ", ";border-radius:8px;box-shadow:", ";margin-bottom:1rem;cursor:pointer;:hover{box-shadow:", ";}background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows.extraBlack;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.cardsBackgroundColor;
});
var Header = styled.div.withConfig({
  displayName: "Large__Header",
  componentId: "sc-lauheu-1"
})(["padding:24px;text-align:center;img{width:88px;height:88px;border-radius:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
});
var Body = styled.div.withConfig({
  displayName: "Large__Body",
  componentId: "sc-lauheu-2"
})(["padding:0 24px;"]);
var Facts = styled.div.withConfig({
  displayName: "Large__Facts",
  componentId: "sc-lauheu-3"
})(["display:flex;flex-wrap:wrap;"]);
var Fact = styled.div.withConfig({
  displayName: "Large__Fact",
  componentId: "sc-lauheu-4"
})(["width:50%;margin-bottom:18px;"]);
var FactHeader = styled.div.withConfig({
  displayName: "Large__FactHeader",
  componentId: "sc-lauheu-5"
})(["color:", ";", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.uiD;
}, textEllipsis);
var FactValue = styled.div.withConfig({
  displayName: "Large__FactValue",
  componentId: "sc-lauheu-6"
})(["color:", ";", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.terciary;
}, textEllipsis);
var Title = styled(H5).withConfig({
  displayName: "Large__Title",
  componentId: "sc-lauheu-7"
})(["display:block;", ";font-size:18px;line-height:20px;color:", ";"], textEllipsis, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.terciaryD;
});
export var Large = function Large(_ref9) {
  var managementCompany = _ref9.managementCompany,
    productType = _ref9.productType;
  var theme = useTheme();
  var imageSrc = getManagementCompanyIconUrl(managementCompany);
  var url = getManagementCompanyPath(theme, productType, managementCompany);
  var funds = managementCompany.stats ? managementCompany.stats.funds : '-';
  var members = managementCompany.organization ? managementCompany.organization.stats.subscribers : null;
  return React.createElement(Inner, {
    href: url,
    title: managementCompany.name
  }, React.createElement(Header, null, imageSrc ? React.createElement(Image, {
    src: imageSrc,
    width: 88,
    height: 88,
    alt: managementCompany.name
  }) : null, React.createElement(Title, {
    as: "h4"
  }, managementCompany.name)), React.createElement(Body, null, React.createElement(Facts, null, React.createElement(Fact, null, React.createElement(FactHeader, null, productType.shortPlural), React.createElement(FactValue, null, funds)), React.createElement(Fact, null, React.createElement(FactHeader, null, "Miembros"), React.createElement(FactValue, null, React.createElement(NumberLabel, {
    value: members,
    decimals: 0
  }))), React.createElement(Fact, null, React.createElement(FactHeader, null, "Patrimonio"), React.createElement(FactValue, null, React.createElement(AssetsLabel, {
    value: managementCompany.stats ? managementCompany.stats.assets : null,
    scale: "milliard",
    decimals: 0
  }))))));
};